import { useStatusQueryFilter } from '@app/modules/logger/screens/status/hooks/useStatusQueryFilter';
import { ControlledSearchBox } from '@ui/components';
import { useIntl } from 'react-intl';

export function StatusesTextFilter() {
  const { $t } = useIntl();
  const { queryParams, setQueryParams } = useStatusQueryFilter();

  return (
    <ControlledSearchBox
      className="search-stations"
      placeholder={$t({
        id: 'logger.statusScreen.stationsFilter.placeholder',
        defaultMessage: 'Filtrar emisoras',
      })}
      value={queryParams.text}
      onSearch={(text) => setQueryParams({ text })}
    />
  );
}
